<template>
  <div>
    <h4>CSR Filter</h4>
    <el-card>
      <el-form-item label="Create Date">
        <el-date-picker
          v-model="dateRangePicker"
          type="daterange"
          range-separator="-"
          start-placeholder="From"
          end-placeholder="To"
          format="dd MMM yyyy"
          value-format="yyyy-MM-dd"
          size="mini"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="Area Type">
        <el-checkbox v-model="checkAreaAll">ALL</el-checkbox>
        <el-checkbox-group v-model="checkedAreas" v-show="!checkAreaAll" size="mini">
          <el-checkbox-button
            v-for="item in areaTypes"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Payment Type">
        <el-checkbox v-model="checkPaymentAll">ALL</el-checkbox>
        <el-checkbox-group v-model="checkedPayments" v-show="!checkPaymentAll" size="mini">
          <el-checkbox-button
            v-for="item in paymentTypes"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="Designated">
        <el-checkbox v-model="checkCsrAll">ALL</el-checkbox>
        <transition name="fade">
        <div v-show="!checkCsrAll">
          <div>
            <el-button size="mini" type="primary" @click="addNewLine">+ Add Line</el-button>
            <el-button
              size="mini"
              type="warning"
              plain
              :disabled="!lineSelected"
              @click="handleDelete"
            >Delete Line</el-button>
          </div>
          <el-table
            ref="multipleTable"
            :row-style="{height:'36px'}"
            :style="{width:'396px'}"
            border
            stripe
            size="small"
            :header-cell-style="{background:'#D7D7D7',color:'#000'}"
            @selection-change="handleSelectionChange"
            :data="csrs"
            :row-key="(row)=>row.id"
          >
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column type="index" width="45" align="center"></el-table-column>
            <el-table-column label="CSR Name" width="300">
              <template v-slot="scope">
                <ReportCsrDesignate :rowId="scope.row.id" />
              </template>
            </el-table-column>
          </el-table>
        </div>
        </transition>
      </el-form-item>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ReportCsrDesignate from './ReportCsrDesignate'

export default {
  name: 'ReportCsr',
  components: {
    ReportCsrDesignate
  },
  data () {
    return {
      lineSelected: false
    }
  },
  computed: {
    ...mapState('report', [
      'csrCreated',
      'areasAll',
      'selectedAreas',
      'paymentsAll',
      'selectedPayments',
      'csrAll',
      'selectedCsrs'
    ]),
    ...mapState(['areaTypes', 'paymentTypes']),
    dateRangePicker: {
      get () {
        return this.csrCreated
      },
      set (val) {
        this.setCsrCreated(val)
      }
    },
    checkAreaAll: {
      get () {
        return this.areasAll
      },
      set (val) {
        this.setAreaAll(val)
        if (!val) {
          this.setAreas([])
        }
      }
    },
    checkedAreas: {
      get () {
        return this.selectedAreas
      },
      set (val) {
        this.setAreas(val)

        if (this.selectedAreas.length === this.areaTypes.length) {
          this.setAreaAll(true)
        }
      }
    },
    checkPaymentAll: {
      get () {
        return this.paymentsAll
      },
      set (val) {
        this.setPaymentsAll(val)
        if (!val) {
          this.setPayments([])
        }
      }
    },
    checkedPayments: {
      get () {
        return this.selectedPayments
      },
      set (val) {
        this.setPayments(val)

        if (this.selectedPayments.length === this.paymentTypes.length) {
          this.setPaymentsAll(true)
        }
      }
    },
    checkCsrAll: {
      get () {
        return this.csrAll
      },
      set (val) {
        this.setCSRAll(val)
      }
    },
    csrs: {
      get () {
        return this.selectedCsrs
      }
    }
  },
  methods: {
    ...mapMutations({
      setCsrCreated: 'report/setCsrCreated',
      setAreas: 'report/setAreas',
      setAreaAll: 'report/setAreaAll',
      setPayments: 'report/setPayments',
      setPaymentsAll: 'report/setPaymentsAll',
      addNewLine: 'report/addNewCSRLine',
      setCSRAll: 'report/setCSRAll',
      deleteCSR: 'report/deleteCSR'
    }),
    handleSelectionChange (selection) {
      this.lineSelected = selection.length > 0
    },
    handleDelete () {
      const ids = this.$refs.multipleTable.selection.map(sel => sel.id)
      if (ids.length === 0) {
        return
      }
      ids.forEach(i => this.deleteCSR(i))
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
</style>
